import React, {Component, useRef, useState} from "react";
import axios from "axios";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { Column, Columns, Control, Field } from "@allxsmith/bestax-bulma";
import { getQueryString } from "../../utils";


function VehicleFinder(props) {
  const typeahead = useRef();
  const typeFields = [
    "L1",
    "L2",
    "L3",
    "L4",
    "Car",
    "Low Loader",
    "Truck",
    "Luton",
    "Recovery"
  ];
  const [state, setState] = useState({
    vehicle: props.vehicle,
    searchData: [],
    isLoading: false,
    type: "L1"
  })

  const handleChange = e => {
    setState({ [e.target.name]: e.target.value });
  };

  const handleSearch = query => {
    setState({ isLoading: true });
    axios.get(props.endpoint + `vehiclesearch?search=${query}&tab=fleet`).then(resp =>
      setState({
        isLoading: false,
        searchData: resp.data.results
      })
    );
  };

  const handleVehicleSelect = e => {
    props.selectVehicle(e[0]);
    typeahead.current.clear();
    // this.props.vehicleUpdate(e[0]);
  };




    return (
      <form>
        <Columns isMultiline>
          <Column>
            <Field>
              <Control>
                <AsyncTypeahead
                  useCache={false}
                  {...state}
                  id="typeahead1"
                  labelKey="registration"
                  minLength={2}
                  name={"registration"}
                  onSearch={handleSearch}
                  onChange={handleVehicleSelect}
                  placeholder={"Search"}
                  options={state.searchData}
                  ref={typeahead }
                  className="registration-ui vehicle-finder"
                />
              </Control>
            </Field>
          </Column>
        </Columns>
      </form>
    );
}
export default VehicleFinder;
